
export const MODAL_TYPES = {
  calendar: 'calendar',
  conflict: 'conflict',
  timeoff: 'timeoff',
};

export const WORKLOG_DRAWER_TYPES = {
  update: 'worklog.update',
  weather: 'weather',
  time: 'time',
  comments: 'comments',
  notes: 'notes',

}

export const PAGE_CONTEXTS = {
  schedule: 'schedule',
  workerSchedule: 'workerSchedule',
  timeClock: 'timeClock',
  worklogs: 'worklogs',
};